import axios from "axios";

export default class DownloadApi {

    constructor(api) {
        this.api = api;
    }

    download(link, name) {
        const isCertificate = new URL(link, window.location.href).pathname.startsWith('/behrendt/api/certificates/');
        const download = (client) => client.get(link, {responseType: 'blob'})
            .then(response => {
                const blob = new Blob([response.data], {type: 'application/pdf'})
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = name;
                link.click()
                URL.revokeObjectURL(link.href)
            });
        if (isCertificate && new URL(link, window.location.href).origin === new URL(process.env.VUE_APP_API_HOST, window.location.href).origin) {
            this.api.getRaw(download);
        } else {
            download(axios);
        }
    }
}
